// The wrapper around a Troubleshooting Guide command block, and the toolbar along its top edge. runbook_copy_controller
// (Copy commands, on the right) and runbook_run_controller (Run all, on the left) both put a button in it, and
// whichever connects first makes it — so their buttons share one row instead of sitting on two baselines.
//
// The toolbar sits in the block's top padding, outside the pre, so a long command that scrolls the pre sideways
// leaves the buttons in place, and selecting the block's text takes none of theirs.
export function runbookBlock(pre) {
    const parent = pre.parentElement;
    if (parent?.classList.contains('runbook-block'))
        return parent;
    const block = document.createElement('div');
    block.className = 'runbook-block';
    const toolbar = document.createElement('div');
    toolbar.className = 'runbook-toolbar';
    pre.before(block);
    block.append(toolbar, pre);
    return block;
}
export function runbookToolbar(pre) {
    const block = runbookBlock(pre);
    return block.querySelector(':scope > .runbook-toolbar') ?? block;
}
